module.exports = __webpack_public_path__ + "assets/img/user_innocent_case.06644c93.png";